var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26458 21.0825C7.56185 22.9647 8.52115 24.6791 9.96986 25.917C11.4186 27.155 13.2615 27.8352 15.1671 27.8353H24.8323C26.9543 27.8353 28.9894 26.9924 30.4899 25.4919C31.9903 23.9914 32.8333 21.9563 32.8333 19.8343C32.8333 17.7123 31.9903 15.6772 30.4899 14.1768C28.9894 12.6763 26.9543 11.8333 24.8323 11.8333H15.1671C14.0109 11.8334 12.8684 12.0841 11.8184 12.5681C10.7683 13.0521 9.83566 13.7579 9.08459 14.637C8.33352 15.516 7.7819 16.5474 7.4677 17.6601C7.15351 18.7728 7.08421 19.9404 7.26458 21.0825ZM24.9234 24.1425C25.5259 24.1405 26.1212 24.0119 26.6708 23.7651C27.2205 23.5184 27.7122 23.159 28.1141 22.7101C28.5161 22.2613 28.8193 21.7331 29.0042 21.1597C29.189 20.5863 29.2514 19.9804 29.1873 19.3813C29.0768 18.3261 28.5805 17.3489 27.7935 16.6374C27.0065 15.9258 25.9844 15.53 24.9234 15.5261C24.3209 15.5282 23.7256 15.6568 23.1759 15.9035C22.6263 16.1503 22.1346 16.5097 21.7326 16.9585C21.3307 17.4073 21.0275 17.9355 20.8426 18.509C20.6578 19.0824 20.5954 19.6882 20.6595 20.2873C20.7699 21.3425 21.2663 22.3197 22.0533 23.0313C22.8403 23.7429 23.8624 24.1386 24.9234 24.1425Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.29f5c5bcd40c409b0861f5b7302b3abb.svg";
export { ForwardRef as ReactComponent };